import { NgModule, APP_INITIALIZER } from '@angular/core';
import { AppBaseModule } from 'projects/hp-api/src/lib/app-entry/app.base.module';

// ****** OVERRIDES ************ */
import { AppRoutingBelmModule } from './app-routing.belm.module';
import { AppComponentBelm} from './app.component.belm';
// ****** FIN OVERRIDES ************ */

@NgModule({
  declarations: [
    AppComponentBelm
  ],
  imports: [
    AppBaseModule,
    AppRoutingBelmModule
  ],
  bootstrap: [AppComponentBelm]
})
export class AppModule { }